import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import Extrafinancial from "./Extrafinancial"
import AddIcon from "@material-ui/icons/Add"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangePriceCorona extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  corona_price_id: "",
                  selectedCompany: "",
                  selectedCoronaTime: "",
                  selectedCovarage: "",
                  selectedOld: "",
                  corona_price_desc: "",
                  corona_price_amount: "",
                  corona_price_disc: "",
                  corona_price_deactive: "0",
                  company_logo_url: "",
                  orderBy: "corona_price_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newPriceCorona: true,
                  optionCompany: [],
                  optionCoronaTime: [],
                  optionCovarage: [],
                  optionOld: [],
                  openDialog: false,
            }
      }

      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }

      handleCovarage = (selectedCovarage) => {
            this.setState({ selectedCovarage: selectedCovarage }, () => {})
      }
      handleOld = (selectedOld) => {
            this.setState({ selectedOld: selectedOld }, () => {})
      }

      handleCoronaTime = (selectedCoronaTime) => {
            this.setState({ selectedCoronaTime: selectedCoronaTime }, () => {
                  this.filterPriceCorona()
            })
      }

      handleCompany = (selectedCompany) => {
            this.setState({ selectedCompany: selectedCompany }, () => {
                  this.filterPriceCorona()
            })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ corona_price_deactive: "0" })
            } else {
                  this.setState({ corona_price_deactive: "1" })
            }
      }

      handleSelectRows = (row2) => {
            this.setState(
                  {
                        corona_price_id: row2.corona_price_id,

                        selectedCompany: { value: row2.corona_price_fieldcompany_id, label: row2.company_name, logo: row2.company_logo_url },
                        selectedCoronaTime: { value: row2.corona_price_time_id, label: row2.corona_time_name },
                        selectedCovarage: { value: row2.corona_price_coverage_id, label: row2.corona_coverage_name },
                        selectedOld: { value: row2.corona_price_old_id, label: row2.corona_old_name },
                        corona_price_desc: row2.corona_price_desc,
                        corona_price_amount: row2.corona_price_amount,
                        corona_price_disc: row2.corona_price_disc,

                        corona_price_deactive: row2.corona_price_deactive,
                        company_logo_url: row2.company_logo_url,
                        newPriceCorona: false,
                  },
                  () => {}
            )
      }

      newPriceCorona = (event) => {
            this.setState({
                  corona_price_id: "",
                  selectedCompany: "",
                  selectedCoronaTime: "",
                  selectedCovarage: "",
                  selectedOld: "",
                  corona_price_deactive: "0",
                  company_logo_url: "",
                  corona_price_desc: "0",
                  corona_price_amount: "",
                  corona_price_disc: "0",
                  newPriceCorona: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getPriceCorona()
                                    self.getoptionCompany()
                                    self.getoptionCoronaTime()
                                    self.getoptionCovarage()
                                    self.getoptionOld()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      deletePriceCorona = () => {
            const { corona_price_id } = this.state
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.handleClose()
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getPriceCorona()
                              self.newPriceCorona()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_corona_price")
            fd.append("corona_price_id", corona_price_id)

            xhttp.open("POST", `${constants.BASE_URL}/corona`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getPriceCorona() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {
                                    self.filterPriceCorona()
                              })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_corona_price")

            xhttp.open("POST", `${constants.BASE_URL}/corona`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionCompany = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].fieldcompany_id,
                                          label: arr.data[k].company_name,
                                          logo: arr.data[k].company_logo_url,
                                    })
                              }
                              self.setState({ optionCompany: Company, selectedCompany: Company[0] }, () => {
                                    self.filterPriceCorona()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldcompany")
            fd.append("fieldinsurance", "coronains")
            xhttp.open("POST", `${constants.BASE_URL}/fieldcompany`)
            xhttp.send(fd)
      }

      getoptionCoronaTime = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].corona_time_id, label: arr.data[k].corona_time_name })
                              }
                              self.setState({ optionCoronaTime: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_corona_time")
            xhttp.open("POST", `${constants.BASE_URL}/corona`)
            xhttp.send(fd)
      }

      getoptionCovarage = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].corona_coverage_id, label: arr.data[k].corona_coverage_name })
                              }
                              self.setState({ optionCovarage: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_corona_coverage")
            xhttp.open("POST", `${constants.BASE_URL}/corona`)
            xhttp.send(fd)
      }

      getoptionOld = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].corona_old_id, label: arr.data[k].corona_old_name })
                              }
                              self.setState({ optionOld: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_corona_old")
            xhttp.open("POST", `${constants.BASE_URL}/corona`)
            xhttp.send(fd)
      }

      saveNewPriceCorona = () => {
            const {
                  corona_price_amount,
                  corona_price_desc,
                  corona_price_disc,
                  selectedCompany,
                  selectedCoronaTime,
                  selectedCovarage,
                  selectedOld,
                  corona_price_deactive,
            } = this.state
            if (
                  selectedCompany != "" &&
                  selectedCoronaTime != "" &&
                  selectedCovarage != "" &&
                  selectedOld != "" &&
                  corona_price_disc != "" &&
                  corona_price_amount != "" &&
                  corona_price_desc != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPriceCorona()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_corona_price")

                  fd.append("corona_price_fieldcompany_id", selectedCompany.value)
                  fd.append("corona_price_time_id", selectedCoronaTime.value)
                  fd.append("corona_price_coverage_id", selectedCovarage.value)
                  fd.append("corona_price_old_id", selectedOld.value)
                  fd.append("corona_price_desc", corona_price_desc)
                  fd.append("corona_price_amount", corona_price_amount)
                  fd.append("corona_price_disc", corona_price_disc)
                  fd.append("corona_price_deactive", corona_price_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/corona`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      changePriceCorona2 = () => {
            const {
                  corona_price_id,
                  corona_price_desc,
                  corona_price_amount,
                  corona_price_disc,
                  selectedCompany,
                  selectedCoronaTime,
                  selectedCovarage,
                  selectedOld,
                  corona_price_deactive,
            } = this.state
            if (
                  selectedCompany != "" &&
                  corona_price_desc != "" &&
                  corona_price_amount != "" &&
                  corona_price_disc != "" &&
                  selectedCoronaTime != "" &&
                  selectedCovarage != "" &&
                  selectedOld != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPriceCorona()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "modify_corona_price")
                  fd.append("corona_price_id", corona_price_id)

                  fd.append("corona_price_fieldcompany_id", selectedCompany.value)
                  fd.append("corona_price_time_id", selectedCoronaTime.value)
                  fd.append("corona_price_coverage_id", selectedCovarage.value)
                  fd.append("corona_price_old_id", selectedOld.value)
                  fd.append("corona_price_desc", corona_price_desc)
                  fd.append("corona_price_amount", corona_price_amount)
                  fd.append("corona_price_disc", corona_price_disc)
                  fd.append("corona_price_deactive", corona_price_deactive)

                  xhttp.open("POST", `${constants.BASE_URL}/corona`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangeDisc = (event) => {
            this.setState({ corona_price_disc: event })
      }

      handleChangeDesc = (event) => {
            this.setState({ corona_price_desc: event.target.value })
      }
      handleChangeAmaount = (event) => {
            this.setState({ corona_price_amount: event })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }
      filterPriceCorona = () => {
            const { selectedCompany, selectedCoronaTime, requestinfos } = this.state
            var temparray = requestinfos,
                  temparray2 = [],
                  i
            for (i = 0; i < temparray.length; i++) {
                  if (
                        (selectedCompany.value === 0 || temparray[i].corona_price_fieldcompany_id === selectedCompany.value) &&
                        (selectedCoronaTime === "" ||
                              selectedCoronaTime.value === 0 ||
                              temparray[i].corona_price_time_id === selectedCoronaTime.value)
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            console.log(requestinfos)
            console.log(temparray2)
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      render() {
            const { classes } = this.props
            const {
                  corona_price_disc,
                  corona_price_desc,
                  corona_price_amount,
                  optionCompany,
                  optionCoronaTime,
                  optionCovarage,
                  optionOld,
                  snackMode,
                  snackstr,
                  showSnack,
                  newPriceCorona,
                  corona_price_id,
                  company_logo_url,
                  selectedCompany,
                  selectedCoronaTime,
                  selectedCovarage,
                  selectedOld,
                  corona_price_deactive,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"شماره قیمت بیمه _کرونا: " + corona_price_id}
                                                                  </Typography>
                                                            </Grid>
                                                            <Grid item xs={6}></Grid>

                                                            <Grid item xs={6}></Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img alt="" className={classes.large} src={this.state.selectedCompany.logo} />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">شرکت بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شرکت بیمه"}
                                                                              value={selectedCompany}
                                                                              onChange={this.handleCompany}
                                                                              options={optionCompany}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">مدت زمان بیمه نامه </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"مدت زمان بیمه نامه "}
                                                                              value={selectedCoronaTime}
                                                                              onChange={this.handleCoronaTime}
                                                                              options={optionCoronaTime}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">پوشش بیمه نامه </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"پوشش بیمه نامه"}
                                                                              value={selectedCovarage}
                                                                              onChange={this.handleCovarage}
                                                                              options={optionCovarage}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">سن بیمه شده</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"سن بیمه شده"}
                                                                              value={selectedOld}
                                                                              onChange={this.handleOld}
                                                                              options={optionOld}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="currency"
                                                                        placeholder="مبلغ بیمه نامه"
                                                                        handleInputt={this.handleChangeAmaount}
                                                                        value={corona_price_amount}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="percent"
                                                                        placeholder="تخفیف"
                                                                        handleInputt={this.handleChangeDisc}
                                                                        value={corona_price_disc}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder="  توضیحات"
                                                                        handleInputt={this.handleChangeDesc}
                                                                        value={corona_price_desc}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={corona_price_deactive === "0" ? true : false}
                                                                                          onChange={this.handleChangeDeactive}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="وضعیت قیمت شرکت بیمه"
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {newPriceCorona ? (
                                                                        <Button variant="outlined" color="primary" onClick={this.saveNewPriceCorona}>
                                                                              {"ثبت قیمت بیمه _کرونا جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.newPriceCorona}
                                                                              >
                                                                                    {"قیمت بیمه _کرونا جدید "}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.changePriceCorona2}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.handleClickOpen()
                                                                                    }}
                                                                              >
                                                                                    {" حذف قیمت بیمه _کرونا"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>

                                                            {newPriceCorona ? null : (
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>
                                                            )}
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"corona_price_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "corona_price_id" ? order : false}
                                                                              >
                                                                                    {" آی دی "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "corona_price_id"}
                                                                                          direction={orderBy === "corona_price_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("corona_price_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"company_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شرکت بیمه  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "company_name"}
                                                                                          direction={orderBy === "company_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("company_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"corona_price_time_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"مدت بیمه نامه "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "corona_price_time_id"}
                                                                                          direction={
                                                                                                orderBy === "corona_price_time_id" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("corona_price_time_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"corona_price_coverage_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"پوشش بیمه نامه "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "corona_price_coverage_id"}
                                                                                          direction={
                                                                                                orderBy === "corona_price_coverage_id" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("corona_price_coverage_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"corona_price_old_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"سن بیمه شده"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "corona_price_old_id"}
                                                                                          direction={
                                                                                                orderBy === "corona_price_old_id" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("corona_price_old_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"corona_price_disc"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"تخفیف"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "corona_price_disc"}
                                                                                          direction={orderBy === "corona_price_disc" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("corona_price_disc")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"corona_price_amount"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"مبلغ بیمه نامه"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "corona_price_amount"}
                                                                                          direction={
                                                                                                orderBy === "corona_price_amount" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("corona_price_amount")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"corona_price_deactive"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت قیمت بیمه _کرونا"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "corona_price_deactive"}
                                                                                          direction={
                                                                                                orderBy === "corona_price_deactive" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("corona_price_deactive")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["corona_price_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell key={"corona_price_id"} align={"center"}>
                                                                                                      {row["corona_price_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"company_name"} align={"center"}>
                                                                                                      {row["company_name"]}
                                                                                                      <img
                                                                                                            className={classes.small}
                                                                                                            alt="Remy Sharp"
                                                                                                            src={row["company_logo_url"]}
                                                                                                      />
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"corona_price_time_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["corona_time_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"corona_price_coverage_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["corona_coverage_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"corona_price_old_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["corona_old_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"corona_price_disc"} align={"center"}>
                                                                                                      {row["corona_price_disc"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"corona_price_amount"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["corona_price_amount"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"corona_price_deactive"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["corona_price_deactive"] === "1" ||
                                                                                                      row["corona_price_deactive"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                              <Dialog
                                    open={this.state.openDialog}
                                    onClose={this.handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                              >
                                    <DialogTitle id="alert-dialog-title">{"آیا میخواهید قیمت بیمه _کرونا را حذف نمایید"}</DialogTitle>
                                    <DialogContent>
                                          <DialogContentText id="alert-dialog-description">
                                                ابتدا از عملیات خود مطمئن شوید و سپس پاک کنید
                                          </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                          <Button onClick={this.handleClose} color="primary">
                                                انصراف
                                          </Button>
                                          <Button onClick={this.deletePriceCorona} color="primary" autoFocus>
                                                بله انجام شود
                                          </Button>
                                    </DialogActions>
                              </Dialog>
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangePriceCorona)
